import Disbursement from 'components/global/Disbursement';

export default Disbursement;
